import { render, staticRenderFns } from "./sales_customer_support.vue?vue&type=template&id=c3b1034a&"
import script from "./sales_customer_support.vue?vue&type=script&lang=js&"
export * from "./sales_customer_support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports